<div class="avatar-row-container" [style]="'height: ' + avatarSize + 'rem;'">
	<ng-container *ngFor="let user of directionalUsers; let i = index">
		<div class="avatar-container" [style]="direction + ': ' + i * (avatarSize - 0.25) + 'rem; width: ' + avatarSize + 'rem; height: ' + avatarSize + 'rem; line-height: ' + avatarSize + 'rem; z-index: ' + (directionalUsers.length - i * zIndex) + ';'">
			<app-avatar [user]="user" [avatarSize]="avatarSize"></app-avatar>
		</div>
	</ng-container>
</div>
